import { useEffect, useState } from "react";
import "../../styles/CommonInput.scss";

const CommonInput = ({
  label,
  type = "text",
  value,
  onChange,
  deferred = false,

  icon,
  iconSize = 18,
  rightIcon,
  onRightIconClick,

  filter,
  maxLength = 50,
  disabled = false,
}) => {
  const [localValue, setLocalValue] = useState(value ?? "");

  /* keep local state in sync when parent updates */
  useEffect(() => {
    if (deferred) {
      setLocalValue(value ?? "");
    }
  }, [value, deferred]);

  const handleChange = (e) => {
    if (!deferred) {
      onChange?.(e);
      return;
    }

    let val = e.target.value;
    if (filter) val = filter(val);
    setLocalValue(val);
  };

  const handleBlur = (e) => {
    if (!deferred || disabled) return;

    onChange?.({
      ...e,
      target: {
        ...e.target,
        value: localValue,
      },
    });
  };

  return (
    <div className="stacked-input">
      {icon && (
        <span className="left-icon" style={{ fontSize: iconSize }}>
          {icon}
        </span>
      )}

      <div className="input-content">
        <span className="inside-label">{label}</span>
        <input
          type={type}
          disabled={disabled}
          value={deferred ? localValue : value}
          onChange={handleChange}
          onBlur={handleBlur}
          maxLength={maxLength}
        />
      </div>

      {rightIcon && (
        <span className="right-icon" onClick={onRightIconClick}>
          {rightIcon}
        </span>
      )}
    </div>
  );
};

export default CommonInput;
